import Categories from 'components/blog/categories'
import ShareIcon from 'components/blog/icons/share-icon'
import { Category } from 'types/blog-types'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { PropsWithChildren } from 'react'
import AuthorCardSection from './author'
import FlatCard from './flat'
import s from './styles.module.css'

interface CardProps {
  categories?: [Category?]
  post: any
  type?: 'flat' | 'default'
  isFeature?: boolean
  className?: string
}

export default function Card({
  categories = [],
  post,
  type = 'default',
  isFeature = false,
  className,
}: PropsWithChildren<CardProps>) {
  if (type === 'flat') {
    return (
      <FlatCard isFeature={isFeature} categories={categories} post={post} />
    )
  }
  return (
    <div key={post.fields.id} className={className || s.card}>
      <Link href={`/blog/${post.fields.slug}`} className={s.postLink}>
        {post.fields.featureImage && (
          <div className={s.imageWrapper}>
            <Image
              alt={post.fields.featureImage.fields.title}
              src={`https:${post.fields.featureImage.fields.file.url}`}
              layout="fill"
              objectFit="cover"
            />
          </div>
        )}
        <div className={s.content}>
          <Categories categories={categories} className={s.categories} />
          <h3 className={s.title}>{post.fields.title}</h3>
          <div className={s.bottomContent}>
            <AuthorCardSection post={post} />
            <div>
              <ShareIcon />
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}
